import './ui.css';

/**
 * A small, calm loading spinner (PLAN.md M7 — restrained motion). A hairline ring with an accent
 * arc that rotates; used in the top bar's Run button busy state and any inline async pending UI.
 * Honours reduced motion (the rotation is paused by the global reduced-motion rule). Token-driven.
 */
export interface SpinnerProps {
  /** Diameter in px (default 16, sized to sit inside a button). */
  size?: number;
  /** Stroke colour (a token var). Defaults to currentColor so it inherits the button text colour. */
  color?: string;
  'aria-label'?: string;
}

export function Spinner({
  size = 16,
  color = 'currentColor',
  'aria-label': ariaLabel = 'Loading',
}: SpinnerProps): React.ReactElement {
  return (
    <span
      className="uispinner"
      role="status"
      aria-label={ariaLabel}
      style={{
        width: size,
        height: size,
        borderColor: 'color-mix(in srgb, currentColor 22%, transparent)',
        borderTopColor: color,
      }}
    />
  );
}
